export default __webpack_public_path__ + "static/media/checkSquare.5493682c.svg";